import {
  Component,
  Directive,
  ElementRef,
  HostListener,
  OnInit,
} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {MenuService} from '@core/menu/menu.service';
import {ETipoUsuario, IEmpresa, INotification} from '@core/models';
import {CookieService} from 'ngx-cookie-service';
import { EmpresaService } from '@core/services/empresa.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  menuArray;
  items: MenuItem[];
  selectedItem = '0';
  _token = '0';
  empresa: IEmpresa = null;

  tipoUsuario: ETipoUsuario;

  logoUrl: string = '../../../assets/images/loading.gif';
    logoArchivo: File;
    logoUrlCargado: string = null;
    logoArchivoCargado: any;
  constructor(
    public menuservice: MenuService,
    public myElement: ElementRef,
    private cookie: CookieService,
    private empresaService: EmpresaService,
  ) {
    sessionStorage.getItem('TipoUser')
      ? (this.tipoUsuario = JSON.parse(sessionStorage.getItem('TipoUser')).Id)
      : null;

    this._token = sessionStorage.getItem('token')
      ? sessionStorage.getItem('token')
      : this.cookie.get('token');

      sessionStorage.getItem('Empresa')
      ? (this.empresa = JSON.parse(sessionStorage.getItem('Empresa')))
      : null;
    this.cargarImagen()
  }

  ngOnInit() {
    this.menuservice.clearMenu();
    // console.log(this.tipoUsuario);
    let Dashboard = [];
    switch (this.tipoUsuario) {
      case ETipoUsuario.ADMINISTRADOR_SISTEMA:
        Dashboard = [
          {
            text: 'ADMIN PRINCIPAL',
            link: `/system/admin-principal/mantenedorEmpresas`,
            icon: 'pi-check',
            submenu: [
              {
                text: 'Mantenedor Empresa',
                link: `/system/admin-principal/mantenedorEmpresas/crear`,
              },
              {
                text: 'Listado Empresas',
                link: `/system/admin-principal/listadoEmpresas/${this._token}`,
              },
            ],
          },
        ];
        break;

      case ETipoUsuario.ADMINISTRADOR_EMPRESA:
        Dashboard = [
          {
            text: 'Mantenedor Empresa',
            link: `/system/admin-empresa/configuracionEmpresa/${this._token}`,
            icon: '',
            // submenu: [
            //   {
            //     text: 'Mantenedor Empresa',
                
            //   },
            // ],
          },
        ];
        break;
      case ETipoUsuario.ADMINISTRADOR_INSPECTOR:
        Dashboard = [
          {
            text: 'Mantenedor Empresa',
            link: `/system/admin-empresa/configuracionEmpresa/${this._token}`,
            icon: '',
            // submenu: [
            //   {
            //     text: 'Mantenedor Empresa',
                
            //   },
            // ],
          },
          {
            text: 'Listado denuncias',
            link: `/system/inspector/listadoDenuncias/${this._token}`,
            icon: '',
            // submenu: [
            //   {
            //     text: 'Mantenedor Empresa',
                
            //   },
            // ],
          },
         
        ];
        break;
      case ETipoUsuario.INSPECTOR:
        Dashboard = [
          {
            text: 'Listado Denuncias',
            link: `/system/inspector/listadoDenuncias/${this._token}`,
            icon: '',
            // submenu: [
            //   {
            //     text: 'Listado Denuncias',
            //     link: `/system/inspector/listadoDenuncias/${this._token}`,
            //   },
            // ],
          },
        ];
        break;
    }

    this.items = [
      {label: 'New', icon: 'pi pi-fw pi-plus'},
      {label: 'Open', icon: 'pi pi-fw pi-download'},
      {label: 'Undo', icon: 'pi pi-fw pi-refresh'},
    ];

    this.menuservice.addMenu(Dashboard);
    this.menuArray = this.menuservice.getMenu();
    
  }

  cargarImagen(){
    
    // if (sessionStorage.getItem('logo')) {
    //   this.logoUrlCargado = (sessionStorage.getItem('logo'));
    //   return;
    // }
    // console.log(this.logoUrlCargado);
    this.empresaService.getLogoByEmpresasId(this.empresa.Id).subscribe((data:INotification) => {
      if (data.Type == 2){
        console.log('No hay logo');
        this.logoUrl = '../../../assets/images/placeholder.svg';
        
        return;
      }
      this.logoArchivoCargado = data.Data;
      console.log(this.logoArchivoCargado);
      let extension = this.logoArchivoCargado.Name.split('.').pop();

      let dataType;

      switch (extension) {
        case 'jpg':
          case 'jpeg':
            dataType = 'image/jpeg';
            break;
          case 'png':
            dataType = 'image/png';
            break;
            case 'svg':
              dataType = 'image/svg+xml';
              break;       
          default:
            dataType = 'image/jpeg'; // Valor por defecto
            break;
      }

      this.logoUrlCargado = `data:${dataType};base64,` + this.logoArchivoCargado.binary;
      sessionStorage.setItem('logo', this.logoUrlCargado);
      // this.logoArchivoCargado
      // this.logoUrl = data;
    });
    console.log(this.setUrl());
  }

  setUrl(){
   
    if (this.logoArchivoCargado!=null){
      return this.logoUrlCargado;      
    }
    return this.logoUrl;
  }

  @HostListener('click', ['$event.target']) onClick(e) {
    var content = e.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
}
